export default __webpack_public_path__ + "static/media/pig.9ba0e2dd.svg";